import Vue from 'vue'
import Vuetify from 'vuetify'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    themes: {
      light: {
        // primary: '#ff5e62'
        // primary: '#ff7c64'
        primary: '#ff8765'
        // primary: '#ff9966'
      }
    }
  }
})
